import React from 'react';
import { Box } from '@material-ui/core';
import useLead from 'src/hooks/useLead';
import { Evidences } from 'src/components/Lead/Evidences';
import {
    LeadInfo,
    VehicleInfo,
    FollowInfo,
    AppointmentVisitInfo,
} from 'src/components/Lead/Information';
import { DCPInformation } from 'src/components/Lead/DCPInformation';
import { IncadeaInformation } from 'src/components/Lead/IncadeaInformation';
import { QRCode } from '../../Appointments';
import { getLastAppointment } from '../../Appointments/utils';
import { IAppointment } from 'src/interfaces/appointment';
import { LEAD_FROM_DCP, LEAD_FROM_INCADEA } from 'src/constants/lead/from';

const handleGetLastAppointment = (appointments: IAppointment[]) => {
    const lastAppointment = getLastAppointment(appointments);
    if (lastAppointment?.qrCode) {
        return <QRCode qrCode={lastAppointment?.qrCode} />;
    }
};

export const LeadInformationTables = () => {
    const { lead, loading } = useLead();
  return (
            <Box style={{display: 'flex', flexDirection: 'column', gap: '1em'}}>
                <LeadInfo
                    lead={lead}
                    loading={loading}
                />
                <VehicleInfo
                    lead={lead}
                    loading={loading}
                />
                <FollowInfo
                    lead={lead}
                    loading={loading}
                />
                <AppointmentVisitInfo
                    lead={lead}
                    loading={loading}
                />
                {lead?.from === LEAD_FROM_DCP && lead?.webhookData && (
                    <DCPInformation
                        webhookData={lead?.webhookData}
                        loading={loading}
                    />
                )}
                {lead?.from === LEAD_FROM_INCADEA && lead?.webhookData && (
                    <IncadeaInformation
                        webhookData={lead?.webhookData}
                        loading={loading}
                    />
                )}
                <Evidences
                    lead={lead}
                    loading={loading}
                />
                {handleGetLastAppointment(lead?.appointments || [])}
            </Box>
  )
}
